// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-container .ant-spin-dot-item {
  background-color: white;
}
.lottie-container {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3000;
}
.container-awarded {
  top: 336px;
  left: 728px;
  width: 464px;
  height: 440px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 24px;
  opacity: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  transition: all 200ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.container-awarded .img-awarded {
  margin-top: 5%;
  width: 232px;
  height: 232px;
  animation: img-product 0.5s ease forwards;
  animation-duration: 2s;
  animation-iteration-count: 1;
}
.container-awarded .awarded {
  top: 620px;
  left: 853px;
  width: 214px;
  height: 25px;
  text-align: center;
  font: normal normal normal 18px/28px Poppins;
  letter-spacing: 0px;
  color: #1E1D1E;
  opacity: 1;
  margin-top: 20px;
}
.container-awarded .name-product {
  top: 648px;
  left: 759px;
  width: 90%;
  height: 25px;
  text-align: center;
  font: normal normal 600 17px Poppins;
  color: #1E1D1E;
  opacity: 1;
  padding-bottom: 6%;
}
.container-awarded .btn-awarded {
  width: 90%;
  height: 56px;
  background: #044B97 0% 0% no-repeat padding-box;
  border-radius: 8px;
  cursor: pointer;
  border: 0;
  text-align: center;
  font: normal normal 600 16px/28px Poppins;
  color: #FFFFFF;
  opacity: 1;
}
.container-awarded.animate-show-form {
  width: 680px;
  height: 540px;
  max-width: 97vw;
  margin-top: 0 !important;
  overflow: auto;
}
.container-not-awarded {
  top: 336px;
  left: 728px;
  width: 464px;
  height: 440px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 24px;
  opacity: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.container-not-awarded .txt-not-awarded {
  top: 517px;
  left: 818px;
  width: 284px;
  height: 71px;
  text-align: center;
  font: normal normal bold 28px/32px Poppins;
  color: #054B97;
  opacity: 1;
  padding: 8% 0 0 0;
}
.container-not-awarded .txt-maio-prize {
  top: 610px;
  left: 781px;
  width: 358px;
  height: 97px;
  text-align: center;
  font: normal normal bold 18px/24px Poppins;
  color: #1E1D1E;
  opacity: 1;
  padding: 3% 0 5% 0;
}
.container-not-awarded .txt-rescue-day {
  top: 731px;
  left: 868px;
  width: auto;
  height: 17px;
  text-align: center;
  font: normal normal normal 12px/25px Poppins;
  color: #1E1D1E;
  opacity: 1;
}
@media only screen and (max-width: 768px) {
  .container-awarded {
    width: 100%;
  }
  .container-not-awarded {
    width: 100%;
  }
}
@media only screen and (max-width: 700px) {
  .container-awarded {
    width: 90vw;
    min-height: 57vh;
    margin-top: -4% !important;
  }
  .btn-awarded {
    width: 90% !important;
    margin-top: 2%;
  }
  .container-not-awarded {
    width: 100%;
  }
  .img-ballon1 {
    left: 8% !important;
    z-index: 5000;
  }
  .img-ballon2 {
    left: 95% !important;
    z-index: 5000;
  }
  .img-ballon3 {
    top: 80% !important;
    z-index: 5000;
  }
}
.banner-congrats {
  max-width: 240px;
  max-height: 72.63px;
  position: absolute;
  left: 50%;
  top: 1.2%;
  transform: translate(-50%, -50%);
  z-index: 2000;
  opacity: 0;
  animation: banner-congrats 0.5s ease forwards;
  animation-duration: 1.5s;
  animation-iteration-count: 1;
  animation-delay: 1s;
}
.img-ballon1 {
  max-width: 226px;
  max-height: 260px;
  position: absolute;
  bottom: 10%;
  left: 40px;
  transform: translate(-50%, -50%);
  z-index: 2000;
  opacity: 0;
  animation: ballon-aside-left 0.5s ease forwards;
  animation-duration: 1.5s;
  animation-iteration-count: 1;
  animation-delay: 1s;
}
.img-ballon2 {
  position: absolute;
  max-width: 160px;
  max-height: 184px;
  bottom: 0;
  left: 95%;
  transform: translate(-50%, -50%);
  z-index: 2000;
  opacity: 0;
  animation: ballon-aside-right 0.5s ease forwards;
  animation-duration: 1.5s;
  animation-iteration-count: 1;
  animation-delay: 1s;
}
.img-ballon3 {
  position: absolute;
  max-width: 160px;
  max-height: 184px;
  z-index: 2000;
  top: 90%;
  left: 24%;
  opacity: 0;
  animation: ballon-down 0.5s ease forwards;
  animation-duration: 1.5s;
  animation-iteration-count: 1;
  animation-delay: 1s;
}
.awarded,
.img-awarded,
.name-product {
  animation: animation-product 0.5s ease forwards;
  animation-duration: 4s;
  animation-iteration-count: 1;
}
@keyframes animation-product {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes banner-congrats {
  from {
    top: -12%;
    opacity: 0;
  }
  to {
    top: 1.2%;
    opacity: 1;
  }
}
@keyframes ballon-aside-left {
  from {
    top: 15%;
    opacity: 0;
  }
  to {
    top: 30%;
    opacity: 1;
  }
}
@keyframes ballon-aside-right {
  from {
    bottom: -10%;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
@keyframes ballon-down {
  from {
    top: 120%;
    opacity: 0;
  }
  to {
    top: 90%;
    opacity: 1;
  }
}
@keyframes img-product {
  from {
    width: 50%;
    height: 50%;
    opacity: 0;
  }
  to {
    width: 100%;
    height: 100%;
    opacity: 1;
  }
}
@keyframes show-form {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.PopBalloomAddressFromContainer {
  width: 100%;
  animation: show-form 0.5s ease forwards;
}
.PopBalloomAddressContent {
  max-height: 540px;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/components/PopBallon/PopAnimation/popProduct.less"],"names":[],"mappings":"AAGA;EAEQ,uBAAA;AAHR;AAOA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;AALJ;AAQA;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,4DAAA;AANJ;AAPA;EAgBQ,cAAA;EACA,YAAA;EACA,aAAA;EAEA,yCAAA;EACA,sBAAA;EACA,4BAAA;AAPR;AAfA;EA0BQ,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AARR;AA3BA;EAuCQ,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AATR;AAtCA;EAmDQ,UAAA;EACA,YAAA;EACA,+CAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;EACA,UAAA;AAVR;AAcA;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,cAAA;AAZJ;AAiBA;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AAfJ;AAGA;EAeQ,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;AAfR;AARA;EA2BQ,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AAhBR;AAnBA;EAuCQ,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,cAAA;EACA,UAAA;AAjBR;AAqBA;EACI;IACI,WAAA;EAnBN;EAsBE;IACI,WAAA;EApBN;AACF;AAuBA;EACI;IACI,WAAA;IACA,gBAAA;IACA,0BAAA;EArBN;EAwBE;IACI,qBAAA;IACA,cAAA;EAtBN;EAyBE;IACI,WAAA;EAvBN;EA0BE;IACI,mBAAA;IACA,aAAA;EAxBN;EA2BE;IACI,oBAAA;IACA,aAAA;EAzBN;EA4BE;IACI,mBAAA;IACA,aAAA;EA1BN;AACF;AA8BA;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EAEA,UAAA;EACA,6CAAA;EACA,wBAAA;EACA,4BAAA;EACA,mBAAA;AA7BJ;AAgCA;EAEI,gBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gCAAA;EACA,aAAA;EAEA,UAAA;EACA,+CAAA;EACA,wBAAA;EACA,4BAAA;EACA,mBAAA;AAjCJ;AAoCA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EAGA,UAAA;EACA,gDAAA;EACA,wBAAA;EACA,4BAAA;EACA,mBAAA;AApCJ;AAuCA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,yCAAA;EACA,wBAAA;EACA,4BAAA;EACA,mBAAA;AArCJ;AA0CA;;;EAGI,+CAAA;EACA,sBAAA;EACA,4BAAA;AAxCJ;AA2CA;EACI;IACI,UAAA;EAzCN;EA4CE;IACI,UAAA;EA1CN;AACF;AA6CA;EACI;IACI,SAAA;IACA,UAAA;EA3CN;EA8CE;IACI,SAAA;IACA,UAAA;EA5CN;AACF;AAgDA;EACI;IACI,QAAA;IACA,UAAA;EA9CN;EAiDE;IACI,QAAA;IACA,UAAA;EA/CN;AACF;AAsDA;EACI;IACI,YAAA;IACA,UAAA;EApDN;EAuDE;IACI,SAAA;IACA,UAAA;EArDN;AACF;AA4DA;EACI;IACI,SAAA;IACA,UAAA;EA1DN;EA6DE;IAEI,QAAA;IACA,UAAA;EA5DN;AACF;AA+DA;EACI;IACI,UAAA;IACA,WAAA;IACA,UAAA;EA7DN;EAgEE;IACI,WAAA;IACA,YAAA;IACA,UAAA;EA9DN;AACF;AAkEA;EACI;IACI,UAAA;EAhEN;EAmEE;IACI,UAAA;EAjEN;AACF;AAoEA;EACI,WAAA;EACA,uCAAA;AAlEJ;AAqEA;EACI,iBAAA;EACA,sBAAA;AAnEJ","sourcesContent":["// Container dos ganhadores\n\n\n.product-container {\n    .ant-spin-dot-item {\n        background-color: white;\n    }\n}\n\n.lottie-container {\n    position: absolute;\n    top: 10%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 3000; // Garante que o Lottie fique acima dos outros elementos\n}\n\n.container-awarded {\n    top: 336px;\n    left: 728px;\n    width: 464px;\n    height: 440px;\n    background: #FFFFFF;\n    box-shadow: 0px 3px 6px #00000029;\n    border-radius: 24px;\n    opacity: 1;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    transition: all 200ms cubic-bezier(0.68, -0.55, 0.265, 1.55);\n\n    .img-awarded {\n        margin-top: 5%;\n        width: 232px;\n        height: 232px;\n\n        animation: img-product 0.5s ease forwards;\n        animation-duration: 2s;\n        animation-iteration-count: 1;\n    }\n\n    .awarded {\n        top: 620px;\n        left: 853px;\n        width: 214px;\n        height: 25px;\n        text-align: center;\n        font: normal normal normal 18px/28px Poppins;\n        letter-spacing: 0px;\n        color: #1E1D1E;\n        opacity: 1;\n        margin-top: 20px;\n    }\n\n    .name-product {\n        top: 648px;\n        left: 759px;\n        width: 90%;\n        height: 25px;\n        text-align: center;\n        font: normal normal 600 17px Poppins;\n        color: #1E1D1E;\n        opacity: 1;\n        padding-bottom: 6%;\n    }\n\n    .btn-awarded {\n        width: 90%;\n        height: 56px;\n        background: #044B97 0% 0% no-repeat padding-box;\n        border-radius: 8px;\n        cursor: pointer;\n        border: 0;\n        text-align: center;\n        font: normal normal 600 16px/28px Poppins;\n        color: #FFFFFF;\n        opacity: 1;\n    }\n}\n\n.container-awarded.animate-show-form {\n    width: 680px;\n    height: 540px;\n    max-width: 97vw;\n    margin-top: 0 !important;\n    overflow: auto;\n}\n\n// Container dos NÃO Ganhadores\n\n.container-not-awarded {\n    top: 336px;\n    left: 728px;\n    width: 464px;\n    height: 440px;\n    background: #FFFFFF;\n    box-shadow: 0px 3px 6px #00000029;\n    border-radius: 24px;\n    opacity: 1;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n\n    .txt-not-awarded {\n        top: 517px;\n        left: 818px;\n        width: 284px;\n        height: 71px;\n        text-align: center;\n        font: normal normal bold 28px/32px Poppins;\n        color: #054B97;\n        opacity: 1;\n        padding: 8% 0 0 0;\n    }\n\n    .txt-maio-prize {\n        top: 610px;\n        left: 781px;\n        width: 358px;\n        height: 97px;\n        text-align: center;\n        font: normal normal bold 18px/24px Poppins;\n        color: #1E1D1E;\n        opacity: 1;\n        padding: 3% 0 5% 0;\n    }\n\n    .txt-rescue-day {\n        top: 731px;\n        left: 868px;\n        width: auto;\n        height: 17px;\n        text-align: center;\n        font: normal normal normal 12px/25px Poppins;\n        color: #1E1D1E;\n        opacity: 1;\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .container-awarded {\n        width: 100%;\n    }\n\n    .container-not-awarded {\n        width: 100%;\n    }\n}\n\n@media only screen and (max-width: 700px) {\n    .container-awarded {\n        width: 90vw;\n        min-height: 57vh;\n        margin-top: -4% !important;\n    }\n\n    .btn-awarded {\n        width: 90% !important;\n        margin-top: 2%;\n    }\n\n    .container-not-awarded {\n        width: 100%;\n    }\n\n    .img-ballon1 {\n        left: 8% !important;\n        z-index: 5000;\n    }\n\n    .img-ballon2 {\n        left: 95% !important;\n        z-index: 5000;\n    }\n\n    .img-ballon3 {\n        top: 80% !important;\n        z-index: 5000;\n    }\n}\n\n//ESTILOS BALÕES\n.banner-congrats {\n    max-width: 240px;\n    max-height: 72.63px;\n    position: absolute;\n    left: 50%;\n    top: 1.2%;\n    transform: translate(-50%, -50%);\n    z-index: 2000;\n\n    opacity: 0;\n    animation: banner-congrats 0.5s ease forwards;\n    animation-duration: 1.5s;\n    animation-iteration-count: 1;\n    animation-delay: 1s;\n}\n\n.img-ballon1 {\n\n    max-width: 226px;\n    max-height: 260px;\n\n    position: absolute;\n    bottom: 10%;\n    left: 40px;\n    transform: translate(-50%, -50%);\n    z-index: 2000;\n\n    opacity: 0;\n    animation: ballon-aside-left 0.5s ease forwards;\n    animation-duration: 1.5s;\n    animation-iteration-count: 1;\n    animation-delay: 1s;\n}\n\n.img-ballon2 {\n    position: absolute;\n    max-width: 160px;\n    max-height: 184px;\n    bottom: 0;\n    left: 95%;\n    transform: translate(-50%, -50%);\n    z-index: 2000;\n\n\n    opacity: 0;\n    animation: ballon-aside-right 0.5s ease forwards;\n    animation-duration: 1.5s;\n    animation-iteration-count: 1;\n    animation-delay: 1s;\n}\n\n.img-ballon3 {\n    position: absolute;\n    max-width: 160px;\n    max-height: 184px;\n    z-index: 2000;\n    top: 90%;\n    left: 24%;\n    opacity: 0;\n    animation: ballon-down 0.5s ease forwards;\n    animation-duration: 1.5s;\n    animation-iteration-count: 1;\n    animation-delay: 1s;\n}\n\n// ANIMAÇÕES\n\n.awarded,\n.img-awarded,\n.name-product {\n    animation: animation-product 0.5s ease forwards;\n    animation-duration: 4s;\n    animation-iteration-count: 1;\n}\n\n@keyframes animation-product {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes banner-congrats {\n    from {\n        top: -12%;\n        opacity: 0;\n    }\n\n    to {\n        top: 1.2%;\n        opacity: 1;\n    }\n}\n\n//1\n@keyframes ballon-aside-left {\n    from {\n        top: 15%;\n        opacity: 0;\n    }\n\n    to {\n        top: 30%;\n        opacity: 1;\n    }\n\n    // top: 30%;\n    // right: 65%;\n}\n\n//2\n@keyframes ballon-aside-right {\n    from {\n        bottom: -10%;\n        opacity: 0;\n    }\n\n    to {\n        bottom: 0;\n        opacity: 1;\n    }\n\n    // bottom: 20%;\n    // left: 117%;\n}\n\n//3\n@keyframes ballon-down {\n    from {\n        top: 120%;\n        opacity: 0;\n    }\n\n    to {\n\n        top: 90%;\n        opacity: 1;\n    }\n}\n\n@keyframes img-product {\n    from {\n        width: 50%;\n        height: 50%;\n        opacity: 0;\n    }\n\n    to {\n        width: 100%;\n        height: 100%;\n        opacity: 1;\n    }\n}\n\n//FormAddress\n@keyframes show-form {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.PopBalloomAddressFromContainer {\n    width: 100%;\n    animation: show-form 0.5s ease forwards;\n}\n\n.PopBalloomAddressContent {\n    max-height: 540px;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
